export const checkIfChrome = () => {
  var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  return isChrome;
};